<template>
  <div v-if="user.id">
    <NewEmployee />
  </div>
</template>

<script>
import NewEmployee from '@/components/hr/new-employee.vue'

import { mapState, mapGetters } from 'vuex'

export default {
  components: {
    NewEmployee
  },
  created () {
  },
  watch: {
  },
  computed: {
    ...mapState('userAuth', [
      'user',
    ]),
  },
  data: function() {
    return { }
  },
}
</script>
